import { InjectionToken } from "@angular/core";

export const ENV_CONFIG = new InjectionToken<any>('env.config');
